import { Box } from "@primer/react";
import { useState } from "react";
import QuanHeGiaDinhHocSinh from "./QuanHeGiaDinhHocSinh";
import AnhChiEmPage from "./anh-chi-em/AnhChiEmPage";

interface HocSinh {
    id: number;
    ho_ten: string;
    ma_hs: string;
    ma_tn: string;
    ngay_sinh: string;
    dm_gioitinh_id: number;
    gioi_tinh: string;
    ten_he: string;
    ten_lop: string;
    trang_thai: string;
}

interface Props {
    hocSinh: HocSinh;
}

const QuanHeGiaDinhLayout: React.FC<Props> = ({ hocSinh }) => {
    const [selectedTab, setSelectedTab] = useState<"parents" | "ace">("parents");

    return (
        <Box>
          
            <Box sx={{ display: "grid", gap: 3 }}>
                <QuanHeGiaDinhHocSinh hocSinh={hocSinh} />
                <AnhChiEmPage hocSinh={hocSinh} />
            </Box>
        </Box>
    );
};

export default QuanHeGiaDinhLayout;
